import { subscribe } from '../common/errors/sagas';
import { notificationError, notificationInfo } from '../common/errors/notificationTypes';

const pre = 'COMMODITYFUTUREREPORT/';

// global
export const SET_GRID_SORTS = `${pre}SET_GRID_SORTS`;

// monthly upload
export const SET_DEFAULT_FILTERS = `${pre}SET_DEFAULT_FILTERS`;
export const SET_MONTHLY_UPLOAD_INITIALISED = `${pre}SET_MONTHLY_UPLOAD_INITIALISED`;
export const SET_MONTHLY_UPLOAD_LOADING = `${pre}SET_MONTHLY_UPLOAD_LOADING`;
export const SET_RUNDATE = `${pre}SET_RUNDATE`;
export const COMMODITY_REPORT_MONTHLY_UPLOAD_LOADED = `${pre}COMMODITY_REPORT_MONTHLY_UPLOAD_LOADED`;
export const UPLOAD_MONTHLY_FILE = `${pre}UPLOAD_MONTHLY_FILE`;
export const UPLOAD_MONTHLY_FILE_FAILED = `${pre}UPLOAD_MONTHLY_FILE_FAILED`;
export const UPLOAD_MONTHLY_FILE_SUCCESS = `${pre}UPLOAD_MONTHLY_FILE_SUCCESS`;
export const UPLOAD_MONTHLY_FILE_SUCCESS_CONFIRM = `${pre}UPLOAD_MONTHLY_FILE_SUCCESS_CONFIRM`;
export const VALIDATE_MONTHLY_FILE = `${pre}VALIDATE_MONTHLY_FILE`;
export const VALIDATE_MONTHLY_FILE_FAILED = `${pre}VALIDATE_MONTHLY_FILE_FAILED`;
export const VALIDATE_MONTHLY_FILE_SUCCESS = `${pre}VALIDATE_MONTHLY_FILE_SUCCESS`;
export const GET_MONTHLY_FILE_UPLOADS = `${pre}GET_MONTHLY_FILE_UPLOADS`;
export const GET_MONTHLY_FILE_UPLOADS_SUCCESS = `${pre}GET_MONTHLY_FILE_UPLOADS_SUCCESS`;
export const GET_MONTHLY_FILE_UPLOADS_FAILED = `${pre}GET_MONTHLY_FILE_UPLOADS_FAILED`;
export const REFRESH_MONTHLY_UPLOAD_DATA = `${pre}REFRESH_MONTHLY_UPLOAD_DATA`;

subscribe(UPLOAD_MONTHLY_FILE_SUCCESS_CONFIRM, 'File uploaded successfully', notificationInfo);
subscribe(UPLOAD_MONTHLY_FILE_FAILED, 'There was an error uploading the file', notificationError);
subscribe(GET_MONTHLY_FILE_UPLOADS_FAILED, 'There was an error getting file uploads', notificationError);
subscribe(VALIDATE_MONTHLY_FILE_FAILED, 'Validation of Monthly file failed. \nPlease Check File!', notificationError);


// report export
export const SET_EXPORT_LOADING = `${pre}SET_EXPORT_LOADING`;
export const SET_EXPORT_INITIALISED = `${pre}SET_EXPORT_INITIALISED`;
export const COMMODITY_REPORT_EXPORT_LOADED = `${pre}COMMODITY_REPORT_EXPORT_LOADED`;
export const GET_COMMODITY_REPORTS = `${pre}GET_COMMODITY_REPORTS`;
export const GET_COMMODITY_REPORTS_SUCCESS = `${pre}GET_COMMODITY_REPORTS_SUCCESS`;
export const GET_COMMODITY_REPORTS_FAILED = `${pre}GET_COMMODITY_REPORTS_FAILED`;
export const SET_ACTIVE_VALUE = `${pre}SET_ACTIVE_VALUE`;
export const SET_ROW_CHECKED = `${pre}SET_ROW_CHECKED`;
export const SET_ALL_ROWS_CHECKED = `${pre}SET_ALL_ROWS_CHECKED`;
export const EXPORT_COMMODITY_REPORTS = `${pre}EXPORT_COMMODITY_REPORTS`;
export const EXPORT_COMMODITY_REPORT_SUCCESS = `${pre}EXPORT_COMMODITY_REPORT_SUCCESS`;
export const EXPORT_COMMODITY_REPORT_FAILED = `${pre}EXPORT_COMMODITY_REPORT_FAILED`;
export const REFRESH_REPORT_DATA = `${pre}REFRESH_REPORT_DATA`;
subscribe(GET_COMMODITY_REPORTS_FAILED, 'There was an error getting commodity reports', notificationError);
subscribe(EXPORT_COMMODITY_REPORT_FAILED, 'There was an error exporting the commodity reports', notificationError);

// daily files
export const DAILY_FILES_LOADED = `${pre}DAILY_FILES_LOADED`;
export const SET_DAILY_FILES_LOADING = `${pre}SET_DAILY_FILES_LOADING`;
export const SET_DAILY_FILES_INITIALISED = `${pre}SET_DAILY_FILES_INITIALISED`;
export const GET_DAILY_FILES = `${pre}GET_DAILY_FILES`;
export const GET_DAILY_FILES_SUCCESS = `${pre}GET_DAILY_FILES_SUCCESS`;
export const GET_DAILY_FILES_FAILED = `${pre}GET_DAILY_FILES_FAILED`;
export const REFRESH_DAILY_FILES = `${pre}REFRESH_DAILY_FILES`;
subscribe(GET_DAILY_FILES_FAILED, 'There was an error retrieving the daily files in the database', notificationError);

export const dailyFileConnected = search => ({
    type: DAILY_FILES_LOADED,
    search
});

export const setDailyFilesLoading = loading => ({
    type: SET_DAILY_FILES_LOADING,
    loading
});

export const setDailyFilesInitialised = initialised => ({
    type: SET_DAILY_FILES_INITIALISED,
    initialised
});

export const getDailyFiles = () => ({
    type: GET_DAILY_FILES
});

export const getDailyFilesSuccess = result => ({
    type: GET_DAILY_FILES_SUCCESS,
    result
});

export const getDailyFilesFailed = error => ({
    type: GET_DAILY_FILES_FAILED,
    error
});

export const refreshDailyFiles = () => ({
    type: REFRESH_DAILY_FILES    
});

export const validateMonthlyFile = (file) => ({
    type: VALIDATE_MONTHLY_FILE,
    file
});

export const validateMonthlyFileFailed = (error) => ({
    type: VALIDATE_MONTHLY_FILE_FAILED,
    error
});

export const validateMonthlyFileSuccess = (result) => ({
    type: VALIDATE_MONTHLY_FILE_SUCCESS,
    result
});

export const exportReports = (ids) => ({
    type: EXPORT_COMMODITY_REPORTS,
    ids
});

export const exportReportsFailed = (error) => ({
    type: EXPORT_COMMODITY_REPORT_FAILED,
    error
});

export const exportReportsSuccess = (downloadFile) => ({
    type: EXPORT_COMMODITY_REPORT_SUCCESS,
    downloadFile
});

export const setActiveValue = (key, value, rowId) => ({
    type: SET_ACTIVE_VALUE,
    key,
    value,
    rowId
});

export const setRowChecked = (id, checked) => ({
    type: SET_ROW_CHECKED,
    id,
    checked
});

export const setAllRowsChecked = checked => ({
    type: SET_ALL_ROWS_CHECKED,
    checked
});

export const setGridSorts = (gridId, sorting) => ({
    type: SET_GRID_SORTS,
    gridId,
    sorting
});
export const getMonthlyFileUploadsSuccess = rows => ({
    type: GET_MONTHLY_FILE_UPLOADS_SUCCESS,
    rows
});

export const getMonthlyFileUploads = request => ({
    type: GET_MONTHLY_FILE_UPLOADS,
    request
});
export const getMonthlyFileUploadsFailed = error => ({
    type: GET_MONTHLY_FILE_UPLOADS_FAILED,
    error
});

export const getCommodityReportsSuccess = rows => ({
    type: GET_COMMODITY_REPORTS_SUCCESS,
    rows
});

export const getCommodityReports = request => ({
    type: GET_COMMODITY_REPORTS,
    request
});
export const getCommodityReportsFailed = error => ({
    type: GET_COMMODITY_REPORTS_FAILED,
    error
});

export const refreshMonthlyUploadData = () => ({
    type: REFRESH_MONTHLY_UPLOAD_DATA
});

export const refreshReportData = () => ({
    type: REFRESH_REPORT_DATA
});

export const setDefaultFilters = filters => ({
    type: SET_DEFAULT_FILTERS,
    filters
});
export const setMonthlyUploadInitialised = initialised => ({
    type: SET_MONTHLY_UPLOAD_INITIALISED,
    initialised
});

export const setExportInitialised = initialised => ({
    type: SET_EXPORT_INITIALISED,
    initialised
});

export const setRunDate = date => ({
    type: SET_RUNDATE,
    date
});

export const setMonthlyUploadLoading = loading => ({
    type: SET_MONTHLY_UPLOAD_LOADING,
    loading
});

export const setExportLoading = loading => ({
    type: SET_EXPORT_LOADING,
    loading
});

export const uploadFileConnected = search => ({
    type: COMMODITY_REPORT_MONTHLY_UPLOAD_LOADED,
    search
});

export const exportConnected = search => ({
    type: COMMODITY_REPORT_EXPORT_LOADED,
    search
});

export const uploadMonthlyFile = data => ({
    type: UPLOAD_MONTHLY_FILE,
    data
});
export const uploadMonthlyFileSuccess = result => ({
    type: UPLOAD_MONTHLY_FILE_SUCCESS,
    result
});
export const uploadMonthlyFileSuccessConfirm = error => ({
    type: UPLOAD_MONTHLY_FILE_SUCCESS_CONFIRM,
    error
});
export const uploadMonthlyFileFailed = error => ({
    type: UPLOAD_MONTHLY_FILE_FAILED,
    error
});

